"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var _sizes = require("HubStyleTokens/sizes");

var _colors = require("HubStyleTokens/colors");

var _Use = require("./utils/Use");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  margin-left: ", ";\n  right: 0;\n  left: 0;\n  top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CLOSE_BUTTON_USE_COLOR_MAP = {
  default: _colors.EERIE,
  shepherd: _colors.OLAF,
  longform: _colors.CALYPSO,
  tooltip: _colors.OLAF,
  'tooltip-danger': _colors.OLAF,
  unstyled: _colors.EERIE
};
var StyledCloseButton = (0, _styledComponents.default)(_UICloseButton.default).withConfig({
  displayName: "UIPopoverCloseButton__StyledCloseButton",
  componentId: "pg590c-0"
})(_templateObject(), function (_ref) {
  var size = _ref.size;
  return size === 'sm' || size === 'small' ? null : parseInt(_sizes.MEDIUM_CLOSE_BUTTON_SIZE, 10) + 4 + "px";
}, function (_ref2) {
  var size = _ref2.size;
  return (size === 'sm' || size === 'small' ? 0 : parseInt(_sizes.POPOVER_PADDING_X, 10) - parseInt(_sizes.POPOVER_PADDING_Y, 10)) + "px";
});

var UIPopoverCloseButton = _react.default.createClass({
  displayName: "UIPopoverCloseButton",
  propTypes: {
    color: _react.PropTypes.string,
    size: _UICloseButton.default.propTypes.size,
    popoverUse: _react.PropTypes.oneOf(Object.keys(_Use.USE_CLASSES))
  },
  getDefaultProps: function getDefaultProps() {
    return {
      size: 'md',
      popoverUse: 'default'
    };
  },
  render: function render() {
    var _this$props = this.props,
        popoverUse = _this$props.popoverUse,
        size = _this$props.size,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["popoverUse", "size"]);
    var computedColor = CLOSE_BUTTON_USE_COLOR_MAP[popoverUse];
    var computedSize = popoverUse === 'longform' ? 'sm' : size;
    return _react.default.createElement(StyledCloseButton, (0, _extends2.default)({
      color: computedColor,
      size: computedSize
    }, rest));
  }
});

var _default = UIPopoverCloseButton;
exports.default = _default;
module.exports = exports.default;